var map = {
	"./dashboard/routes.ts": "./src/router/dashboard/routes.ts",
	"./historico-escolar/emitir-historico-escolar/routes.ts": "./src/router/historico-escolar/emitir-historico-escolar/routes.ts",
	"./historico-escolar/manutencao-de-amparo-legal-para-historico-escolar/routes.ts": "./src/router/historico-escolar/manutencao-de-amparo-legal-para-historico-escolar/routes.ts",
	"./historico-escolar/permitir-inserir-historico/routes.ts": "./src/router/historico-escolar/permitir-inserir-historico/routes.ts",
	"./historico-escolar/permitir-vincular-historico/routes.ts": "./src/router/historico-escolar/permitir-vincular-historico/routes.ts",
	"./historico-escolar/relatorio-de-alunos-com-pendencias-no-historico/routes.ts": "./src/router/historico-escolar/relatorio-de-alunos-com-pendencias-no-historico/routes.ts",
	"./historico-escolar/relatorio-de-alunos-concludentes/routes.ts": "./src/router/historico-escolar/relatorio-de-alunos-concludentes/routes.ts",
	"./historico-escolar/relatorios-de-aluno-em-progressao-parcial/routes.ts": "./src/router/historico-escolar/relatorios-de-aluno-em-progressao-parcial/routes.ts"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/router sync recursive routes.ts$/";